/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Show_ClosedInputs */

const cs_deals_show_closed = /** @type {(inputs: Deals_Show_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit výhru / prohru`)
};

const en_deals_show_closed = /** @type {(inputs: Deals_Show_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show won / lost`)
};

/**
* | output |
* | --- |
* | "Show won / lost" |
*
* @param {Deals_Show_ClosedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_show_closed = /** @type {((inputs?: Deals_Show_ClosedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Show_ClosedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_show_closed(inputs)
	return cs_deals_show_closed(inputs)
});